import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie';

import { Observable, BehaviorSubject, ReplaySubject } from '../util/rxjs';

@Injectable()
export class LocaleService {
  locale$: Observable<string>;
  hadUnsupportedLanguage$: Observable<boolean>;

  get flatpickrLocale() {
    const locale = moment.localeData();
    return {
      is24Hour: !locale.longDateFormat('LT').endsWith('A'),
      firstDayOfWeek: locale.firstDayOfWeek(),
      weekdays: {
        shorthand: locale.weekdaysShort(),
        longhand: locale.weekdays()
      },
      months: {
        shorthand: locale.monthsShort(),
        longhand: locale.months()
      }
    };
  }

  private defaultLocale = 'en';
  private localeCookieKey = 'locale';
  private localeCookieArgs = {
    expires: moment()
      .add(50, 'years')
      .toDate()
  };

  private localeStream = new ReplaySubject<string>(1);
  private hadUnsupportedLanguageStream = new BehaviorSubject<boolean>(false);

  constructor(private cookieService: CookieService, private translateService: TranslateService) {
    this.locale$ = this.localeStream.asObservable();
    this.hadUnsupportedLanguage$ = this.hadUnsupportedLanguageStream.asObservable();
  }

  setLocale$(value: string) {
    moment.locale(value);
    this.cookieService.put(this.localeCookieKey, value, this.localeCookieArgs);
    return this.translateService.use(value).do(() => this.localeStream.next(value));
  }

  setLocale(value: string) {
    this.setLocale$(value).subscribe();
  }

  formatMoment(date: moment.Moment, format: string) {
    return date.locale(moment.locale()).format(format);
  }

  getLocaleOrDefault() {
    let locale = this.cookieService.get(this.localeCookieKey);
    if (locale) {
      if (locale === "ru" || locale === "pl" || locale === "pt") {
        this.hadUnsupportedLanguageStream.next(true);
        locale = "en";
      }
      this.cookieService.put(this.localeCookieKey, locale, this.localeCookieArgs);
      return locale;
    } else {
      this.cookieService.put(this.localeCookieKey, this.defaultLocale, this.localeCookieArgs);
      return this.defaultLocale;
    }
  }
}
